<template>
  <div class="w-full flex flex-col">
    <div class="flex flex-row justify-between items-center gap-2">
      <div class="flex flex-row items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
          <g clip-path="url(#clip0_1736_51291)">
            <path
              d="M12.3753 12.1834C12.3753 13.4038 11.9513 14.4423 11.1032 15.2991C10.2552 16.1558 9.22219 16.5841 8.00432 16.5841C6.76959 16.5841 5.73098 16.138 4.88849 15.2456C4.046 14.3535 3.62476 13.2815 3.62476 12.0296V3.70828C3.62476 2.84044 3.92571 2.10279 4.52761 1.49532C5.12937 0.887843 5.86417 0.584106 6.73201 0.584106C7.6145 0.584106 8.35304 0.906158 8.94761 1.55026C9.54219 2.19436 9.83948 2.96499 9.83948 3.86213V11.6729C9.83948 12.1822 9.66205 12.6175 9.30717 12.9788C8.9523 13.34 8.51985 13.5206 8.00981 13.5206C7.48717 13.5206 7.04835 13.3329 6.69333 12.9575C6.33831 12.5821 6.1608 12.1246 6.1608 11.585V3.64762H7.30344V11.6729C7.30344 11.8704 7.37018 12.0373 7.50366 12.1736C7.63714 12.3098 7.80263 12.378 8.00014 12.378C8.1975 12.378 8.36293 12.3098 8.4964 12.1736C8.62988 12.0373 8.69662 11.8704 8.69662 11.6729V3.69993C8.70219 3.15326 8.51333 2.68777 8.13003 2.30345C7.74673 1.91912 7.27934 1.72696 6.72783 1.72696C6.17897 1.72696 5.71501 1.92784 5.33597 2.3296C4.95706 2.73151 4.76761 3.20572 4.76761 3.75224V12.1834C4.77318 13.0851 5.0893 13.8498 5.71597 14.4775C6.34263 15.1054 7.10644 15.4266 8.00739 15.4412C8.90791 15.4559 9.6734 15.131 10.3039 14.4665C10.9342 13.8022 11.2437 13.0045 11.2324 12.0736V3.64762H12.3753V12.1834Z"
              fill="#696969" />
          </g>
          <defs>
            <clipPath id="clip0_1736_51291">
              <rect width="16" height="16" fill="white" transform="translate(0 0.584106)" />
            </clipPath>
          </defs>
        </svg>
        <h4 class="nxp-review-title">Carta de Apresentação</h4>
      </div>

      <button class="nxp-review-title-action" type="button" @click="$router.push({ name: 'presentation-letter' })">
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
          <path
            d="M4.54 15.4993H5.46625L13.6633 7.30227L12.7371 6.37602L4.54 14.5731V15.4993ZM3.45667 16.5827V14.1164L13.8237 3.73331C13.9358 3.61886 14.0565 3.5374 14.1856 3.48893C14.3148 3.44032 14.4501 3.41602 14.5917 3.41602C14.7333 3.41602 14.8685 3.43872 14.9973 3.48414C15.1262 3.52956 15.251 3.60997 15.3717 3.72539L16.306 4.65164C16.4215 4.77234 16.5032 4.89734 16.5512 5.02664C16.5993 5.15595 16.6233 5.28907 16.6233 5.42602C16.6233 5.57199 16.5981 5.71129 16.5475 5.84393C16.4968 5.97657 16.4163 6.09782 16.306 6.20768L5.92292 16.5827H3.45667ZM13.1921 6.84727L12.7371 6.37602L13.6633 7.30227L13.1921 6.84727Z"
            fill="#4F4F4F" />
        </svg>
        Editar
      </button>
    </div>
    <hr class="custom-hr my-2" />

    <div v-if="show()" class="nxp-review-data flex flex-col px-6">
      <p>
        {{ talent.description }}
      </p>
    </div>

    <div v-else class="w-full flex flex-col items-center justify-center space-y-4 py-8">
      <p class="nxp-review-no-data-text">
        Você ainda não preencheu a sua carta de apresentação profissional.
      </p>
      <button class="nxp-review-no-data-btn" type="button" @click="$router.push({ name: 'presentation-letter' })">
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
          <path
            d="M8.22616 8.75597H2.58252V7.24325H8.22616V1.59961H9.73888V7.24325H15.3825V8.75597H9.73888V14.3996H8.22616V8.75597Z"
            fill="#4F4F4F" />
        </svg>
        Adicionar carta de apresentação
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import EmptyDetailCard from "@/components/dashboard/profile-detail/EmptyDetailCard";

export default {
  name: "presentation-detail-card",
  computed: {
    ...mapState("talent", ["talent"]),
  },
  methods: {
    show() {
      return this.talent.description != "" && this.talent.description != null;
    },
  },
  components: { EmptyDetailCard },
};
</script>

<style lang="scss">
hr {
  height: 1px;
  background-color: rgba(0, 0, 0, 0.1);
  border: none;
}
</style>
